<!-------------------------------------------- HEADER ------------------------------------------------------------>
<mat-toolbar class="toolbar" [ngClass]="envName" >
  <div class="side-block start">
   <button (click)="snav.toggle()" mat-icon-button *ngIf="user !== null && user !== undefined">
      <mat-icon>menu</mat-icon>
    </button>
    <a><img class="logo" src="assets/imgs/capsuleVeoliaRVB.png" alt="Assainissement et Maintenance France Veolia Logo"></a> 
  </div>

  <div class="center-block">
    <span class="title">SACHA</span>
  </div>  

  <div class="side-block end" >
    <div class="side-block" *ngIf="!router.url.includes('/login') && !router.url.includes('/maintenance')">
      <button style="margin-top: -15px;" type="button" aria-label="Toggle sidenav" mat-icon-button [matMenuTriggerFor]="aboveMenu" *ngIf="user">
        <mat-icon aria-label="Side nav toggle icon">account_box</mat-icon>
      </button>
      <h5 *ngIf="user" style="margin-top: -15px;">{{user.nom +' '+ user.prenom}}
        <div *ngIf="isDeleg" style="margin-left: 10px;"><span matBadgePosition="before" matBadge="Délégataire" class="stretch-badge"></span></div>
        <div *ngIf="!isDeleg" style="margin-left: 10px;"><span matBadgePosition="before" matBadge="Standard" class="stretch-badge-standard"></span></div>
      </h5>
      <mat-menu type="button" #aboveMenu="matMenu" yPosition="above">
        <button *ngIf="droitAdminUser || droitAdminRef" type="button" (click)="manager_user()" mat-menu-item >Gestion utilisateur</button>       
        <button type="button" mat-menu-item (click)="delegation()" [innerText]="isDeleg ? 'Profil standard' : 'Profil délégataire'"></button>
        <button type="button" *ngIf="mockEnabled && canUseMock" mat-menu-item (click)="switchToApi()"> API Réelle</button>
        <button type="button" *ngIf="!mockEnabled && canUseMock" mat-menu-item (click)="switchToMock()"> API Simulé</button>
        <button *ngIf="droitAdminRef || droitsInterface" type="button" mat-menu-item (click)="manager_referentiel()"> Gestion Référentiel </button>      
        <button type="button" mat-menu-item (click)="hideUnmaskBP()" *ngIf="bpEnvState" [innerText]="bpDisplayState ? 'Masquer facture' : 'Afficher facture'"></button>
        <button type="button" mat-menu-item (click)="logout()">Déconnexion</button>
      </mat-menu>
    </div>
  </div>
</mat-toolbar>